// extracted by mini-css-extract-plugin
module.exports = {"distance":"_02712f2b3b--distance--EnGTZ","icon":"_02712f2b3b--icon--ylVel"};